import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import ClientLove from "@/components/site/ClientLove";
import BookingCTA from "@/components/site/BookingCTA";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div
      data-testid="home-page"
      className="bg-[color:var(--sr-black)] min-h-screen"
    >
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <ClientLove />
        <BookingCTA />
      </main>
      <Footer />
    </div>
  );
}
